import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const theme = createTheme({
  primaryColor: 'cyan',
  colors: {
    // Custom palette approximating the #00c2a9 brand color
    cyan: [
      '#e0fcf9',
      '#bef4ef',
      '#96e7e0',
      '#6cd9cf',
      '#4accbf',
      '#32c2b4',
      '#20bfb0',
      '#0ca89b',
      '#00968a',
      '#008278',
    ],
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MantineProvider theme={theme} defaultColorScheme="dark">
    <App />
  </MantineProvider>
);

reportWebVitals();
